<template>
  <a-modal
          :title="$t('page_business_data_add_version_remark')"
          width="680px"
          :visible="visible"
          :bodyStyle="{padding: '16px'}"
          @cancel="close"
          :maskClosable="false"
          :confirmLoading="loading"
  >
    <template slot="footer">
      <a-button key="back" @click="close">
        {{$t('cancel')}}
      </a-button>
      <a-button type="primary" @click="save">
        {{$t('save')}}
      </a-button>
    </template>

    <a-form>
      <a-form-item
              :label="$t('page_business_data_version')+':'"
              :label-col="{ span: 7 }"
              :wrapper-col="{ span: 13 }"
      >
        <span>{{ version }}</span>
      </a-form-item>
      <a-form-item
              :label="$t('page_business_data_remark_content')+':'"
              :label-col="{ span: 7 }"
              :wrapper-col="{ span: 13 }"
      >
        <a-textarea
                v-model="remark"
                :placeholder="$t('common_please_input') + $t('page_business_data_remark_content')"
                type="text"
                :rows="8"
                :maxLength="255"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { ProductionCraftServiceProxy, SaveRemarkDTO } from '@/service-proxies/app-v2/product.service-proxies'

const pcsp = new ProductionCraftServiceProxy()

export default Vue.extend({
  name: 'RemarkModal',
  props: ['visible', 'id'],
  data () {
    return {
      remark: '',
      version: '',
      loading: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.getRemark()
      }
    }
  },
  methods: {
    // 获取版本备注
    async getRemark () {
      const res = await pcsp.getRemarkInfo(this.id)
      this.remark = res.remark
      this.version = res.version
    },
    close () {
      this.$emit('close')
    },
    async save () {
      this.loading = true
      let params = {
        craftId: this.id,
        remark: this.remark
      }
      let res = await pcsp.saveCraftRemark(new SaveRemarkDTO(params))
      this.loading = false
      if (res) {
        this.$emit('close')
        this.$message.success(this.$t('page_resource_pool_success'))
      }
    }
  }
})
</script>
